import { gql, useLazyQuery } from '@apollo/client'

const GET_USER = gql`
  query getUser {
    user {
      firstName
      lastName
      coverImageUrl
      email
      id
      cpf
      type
    }
  }
`

export const useGetUser = () => {
  const [getUser, { data, loading, error }] = useLazyQuery(GET_USER)

  return { getUser, data, loading, error }
}
